import React, { PureComponent } from 'react';
import cn from 'classnames';
import { bool, string, func, object, oneOfType, node } from 'prop-types';
import CardHeader from './CardHeader';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import CardTabs from './CardTabs';
import CardWithControls from './CardWithControls';
import CardCollapsible from './CardCollapsible';
import CardNavTabs from './CardNavTabs';
import CardHeaderNav from './CardHeaderNav';
import CardBodyNew from './CardBodyNew';
import Icon from '../Icon/Icon';
import { getLocalStorageCardExpandedProp, setLocalStorageCardExpandedProp } from './cardHelpers';
import CardWithTabs from './CardWithTabs';

const propTypes = {
  tag: oneOfType([func, string]),
  collapsing: bool,
  className: string,
  children: node,
  loading: bool,
  innerRef: oneOfType([object, func, string]),
  localStorageName: string,
  expanded: bool,
};

const defaultProps = {
  tag: 'div',
  collapsing: false,
  loading: false,
  localStorageName: '',
};

class Card extends PureComponent {
  constructor(props) {
    super(props);

    const expanded = props.getExpandedFromProps ? props.expanded : this.checkExpanded();
    this.state = {
      expanded,
    };
  }

  checkExpanded = () => {
    const { localStorageName, collapsing } = this.props;
    if (!collapsing) {
      return true;
    } else {
      if (!localStorageName) {
        return true;
      }
      if (collapsing && localStorageName) {
        const value = getLocalStorageCardExpandedProp(localStorageName);
        if (value !== null && typeof value === 'boolean') {
          return value;
        }
      }
      return true;
    }
  };

  toggle = () => {
    const { localStorageName, collapsing } = this.props;
    this.setState(
      (prevState) => ({
        expanded: !prevState.expanded,
      }),
      () =>
        collapsing && localStorageName
          ? setLocalStorageCardExpandedProp(localStorageName, this.state.expanded)
          : false,
    );
  };

  render() {
    const { expanded } = this.state;
    const {
      className,
      tag: Tag,
      collapsing,
      innerRef,
      children,
      loading,
      localStorageName,
      ...attributes
    } = this.props;

    return (
      <Tag
        ref={innerRef}
        className={cn(className, 'card', {
          'card-collapse': collapsing,
          'card-loading': loading,
          expanded,
        })}
        {...attributes}
      >
        {collapsing && (
          <button type="button" className="card-toggle" onClick={this.toggle}>
            <Icon
              style={!expanded ? { transform: 'rotate(90deg)' } : {}}
              type="chevron-up"
              tag="span"
            />
          </button>
        )}
        {children}
      </Tag>
    );
  }
}

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;
Card.Tabs = CardTabs;
Card.WithControls = CardWithControls;
Card.Collapsible = CardCollapsible;
Card.NavTabs = CardNavTabs;
Card.HeaderNav = CardHeaderNav;
Card.WithTabs = CardWithTabs;
Card.BodyNew = CardBodyNew;

export default Card;
